import dayjs from "dayjs"

export const isCreatedInTwoDays = (
    // unixTimeStamp
    createdAt: number,
    now: dayjs.Dayjs
) => {
    const createdAtDay = dayjs.unix(createdAt)
    const limit = now.subtract(2, "day")
    return createdAtDay.isAfter(limit)
}
